/**
 * Essa diretiva é feita exclusivamente para limpar o campo de busca do select do vuetify versão 2
 * essa versão tem uma limitação, que foi removida na versão 3, porém ainda usamos a versão 2
 * @example <v-autocomplete v-clear-on-select></v-autocomplete>
 */
const directive = (el, binding, vnode) => {
  vnode.componentInstance.$on("change", () => {
    vnode.context.$nextTick(() => {
      vnode.componentInstance.searchInput = "";
    });
  });
};

export default directive;
